<form [formGroup]="formGroup" fxFlex="100" fxLayout="column">
  <div fxFlex="100" fxLayout="column" fxLayoutGap="12px">
    @for (field of fields; track field) {
      <ng-container>
        @if (field.type === 'input') {
          <eg-input
            fxFlex="100"
            [formControlName]="field.formControlName"
            [label]="field.label"
            [placeholder]="field.placeholder"
            [fieldType]="field.fieldType"
          ></eg-input>
        }

        @if (field.type === 'select') {
          <eg-select
            fxFlex="100"
            [items]="field.items"
            [formControlName]="field.formControlName"
            [label]="field.label"
            [placeholder]="field.placeholder"
            [fieldType]="field.fieldType"
          ></eg-select>
        }

        @if (field.type === 'chips') {
          <eg-chips
            [formControlName]="field.formControlName"
            [label]="field.label"
            [placeholder]="field.placeholder"
            [fieldType]="field.fieldType"
          ></eg-chips>
        }

        @if (field.type === 'editor') {
          <eg-text-editor
            [formControlName]="field.formControlName"
            [label]="field.label"
            [placeholder]="field.placeholder"
            [fieldType]="field.fieldType"
          ></eg-text-editor>
        }
      </ng-container>
    }
  </div>
</form>
